'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponseSensor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _http_client_factory = require('../util/http_client_factory');

var _enumerations = require('../util/enumerations');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResponseSensor = exports.ResponseSensor = function () {
  function ResponseSensor(defaultProcessors) {
    _classCallCheck(this, ResponseSensor);

    if (defaultProcessors === undefined) {
      this.defaultProcessors = {
        0: function _() {
          return _http_client_factory.Failure.reject(_enumerations.Severity.ERROR, 'Unable to reach server. Is your computer connected to the Internet?');
        },
        200: function _(response) {
          try {
            return response.json();
          } catch (e) {
            return _http_client_factory.Failure.reject(_enumerations.Severity.ERROR, 'The server response was invalid.');
          }
        },
        default: function _default() {
          return _http_client_factory.Failure.reject(_enumerations.Severity.ERROR);
        }
      };
    } else {
      this.defaultProcessors = defaultProcessors;
    }
  }

  _createClass(ResponseSensor, [{
    key: 'process',
    value: function process(response) {
      var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // console.log("ResponseSensor.process", response, overrides);

      var processors = Object.assign({}, this.defaultProcessors);
      Object.assign(processors, overrides);
      var processor = processors[response.status];
      if (processor === undefined) {
        // console.log('No sensor for fetch http response status, using default', response.status);
        processor = processors['default'];
        return processor(response);
      } else {
        // console.log('Sensor responding', response.status, response, processor);
        return processor(response);
      }
    }
  }, {
    key: 'processError',
    value: function processError(error) {
      if (error.severity !== undefined) {
        // Ours?
        return Promise.reject(error);
      } else {
        // Network failure
        // return Failure.reject(Severity.ERROR, 'Unable to reach server. Is your computer connected to the Internet?');
        return _http_client_factory.Failure.reject(_enumerations.Severity.ERROR, error.message, error);
      }
    }
  }]);

  return ResponseSensor;
}();